<template>
  <section class="section">
    <div class="container">
      <!-- <h1 class="title">E месечна претплата</h1> -->
      <h1 class="title">Куповина месечна претплате за паркинг</h1>
      <b-steps>
        <b-step-item label="E-дневна паркинг карта" icon="account-key">
          <MesecnaPretplataForma />
        </b-step-item>
        <b-step-item label="Корпа" icon="account">
          <Korpa />
        </b-step-item>
        <b-step-item label="Провера" icon="account-plus">
          <Provera />
        </b-step-item>
      </b-steps>
    </div>
  </section>
</template>

<script>
import MesecnaPretplataForma from '../components/MesecnaPretplataForma'
import Korpa from '../components/Korpa'
import Provera from '../components/Provera'

export default {
  components: {
    MesecnaPretplataForma,
    Korpa,
    Provera
  }
}
</script>

<style></style>
